module.exports = __webpack_public_path__ + "img/lgjcjkzxt2.aef534d3.jpg";